<template>

    <div id="services">
        <img class="isHidden" src="@/assets/page/services/background-truck.png" alt="">
        
        <b-container class="d-flex flex-column justify-content-center align-items-start isCenter"  style="min-height: 300px; flex: 1">
            <b-row class="descriptionBox">
                <b-col class="descriptionBox">
                    <h4 style="font-weight: bold;">Serviços que Oferecemos</h4>
                    <p>Atuamos transportando cargas para o mercado nacional
                        e também para portos onde elas são exportadas
                        para fábricas no exterior.
                    </p>
                </b-col>
            </b-row>
        </b-container>
        

        <ServicesCards />
    </div>

</template>

<script>
import ServicesCards from '@/components/users/ServicesCards.vue';

    export default {
        components: {ServicesCards},

    }

</script>

<style scoped lang="scss">

#services {
    width: 100dvw;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: left;
    position: relative;

    img {
        position: absolute;
        width: 900px;
        top: -50px;
        right: 0;
        margin-left: 1rem;
    }

    .descriptionBox {
        width: 40%;
    }
    
}

@media screen and (max-width: 1500px){
    .isHidden {
        display: none !important;
    }

    .isCenter {
        align-items: center !important;
    }
    .descriptionBox {
        width: 100% !important;
        text-align: center;
    }
}

</style>